import styled, { css } from 'styled-components';

import { OVERLAP_SEARCH_AND_SHUFFLE } from '@xing-com/crate-dream-machine-search-bar';
import { IconReaction } from '@xing-com/icons';
import { Section } from '@xing-com/layout-primitives';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  space4XL,
  xdlColorBackground,
  xdlColorText,
  xdlColorMarkerHighlightText,
  spaceXXL,
} from '@xing-com/tokens';

export const StyledJobsSection = styled(Section)`
  position: relative;
  margin-top: -${OVERLAP_SEARCH_AND_SHUFFLE};
`;

export const StyledCarouselSection = styled(Section)<{ $bgColor?: string }>`
  ${({ $bgColor }) => css`
    background: ${$bgColor || xdlColorBackground};
  `}

  padding-top: ${spaceXXL};
  padding-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    padding-top: ${space4XL};
    padding-bottom: ${space4XL};
  }
`;

export const StyledAnchor = styled.a`
  &,
  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: ${xdlColorText};
  }
`;

export const StyledIcon = styled(IconReaction)`
  color: ${xdlColorMarkerHighlightText};
`;
